// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-action-webview iframe{width:100%;min-height:500px}.light-theme .custom-action-webview iframe{border:1px solid #838c90}.dark-theme .custom-action-webview iframe{border:1px solid #9e9589}", ""]);
// Exports
module.exports = exports;
